import { gql } from '@apollo/client'

const GET_TAX_EXEMPTION_STATUS = gql`
  query getTaxExemptionStatus($nonprofitOrgId: Int!) {
    getTaxExemptionStatus(nonprofitOrgId: $nonprofitOrgId) {
      status
    }
  }
`

export default GET_TAX_EXEMPTION_STATUS
